export default __webpack_public_path__ + "static/media/news-3.66407076.png";